<template>
  <svg class="icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19 12H5M5 12L10 7M5 12L10 17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>